export function containForbidChars(
  str: string,
  forbidChars: string | string[],
) {
  if (!str) {
    return {
      contain: false,
      forbidChar: '',
    }
  }
  const forbidCharList = Array.isArray(forbidChars)
    ? forbidChars
    : forbidChars.split('')
  const charList = str?.split('')
  for (const char of charList) {
    if (forbidCharList.includes(char)) {
      return {
        contain: true,
        forbidChar: char,
      }
    }
  }

  return {
    contain: false,
    forbidChar: '',
  }
}
export function containForbidChars(
  str: string,
  forbidChars: string | string[],
) {
  if (!str) {
    return {
      contain: false,
      forbidChar: '',
    }
  }
  const forbidCharList = Array.isArray(forbidChars)
    ? forbidChars
    : forbidChars.split('')
  const charList = str?.split('')
  for (const char of charList) {
    if (forbidCharList.includes(char)) {
      return {
        contain: true,
        forbidChar: char,
      }
    }
  }

  return {
    contain: false,
    forbidChar: '',
  }
}
